module.exports = __webpack_public_path__ + "static/media/33000138.e5798376.png";